<div class="row payment-edit__row">
  <div class="col-12 payment-edit__intro">
    <h3 class="payment-edit__intro-title"
        *appApplyIfNotEmpty="translationService.getTranslation('payment_edit_intro')"
        [innerHTML]="translationService.getTranslation('payment_edit_intro')"></h3>
  </div>
  <div class="col-12 mb-4 payment-edit__description"
       [innerHTML]="translationService.getTranslation('payment_edit_description')">
  </div>
</div>

@if (isLoadingPayment || isSaving) {
  <div class="payment-edit__spinner" style="text-align: center;">
    <app-loading-spinner/>
  </div>
}

<app-general-errors class="payment-edit__errors" [errors]="errorsArr"></app-general-errors>

<mat-card class="payment-edit__card">
  <mat-card-content class="payment-edit__card-content">
    <div class="row">
    @if (!isLoadingPayment && errorsArr.length == 0) {
      <div class="col-12 col-lg-6">
      <form [formGroup]="paymentEditForm" class="mt-3 payment-edit__form">
        <div class="row payment-edit__form-row">
          <ng-container formGroupName="bank">
            <ng-container>
              <div class="mb-5 col-12 payment-edit__iban-current">
                <div class="payment-edit__iban-current-value"
                     [innerHTML]="translationService.getTranslation('iban_current') + ': ' + payment.bank.swiftIBAN | bankAccount ">
                </div>
              </div>
            </ng-container>
            <mat-form-field class="col-12 payment-edit__iban-field">
              <mat-label class="payment-edit__iban-label"
                         [innerHTML]="translationService.getTranslation('payment_iban')"></mat-label>
              <input maxLength="34" matInput formControlName="swiftIBAN" required #iban
                     class="payment-edit__iban-input">
              @if (iban === document?.activeElement && iban.value.length >= 1) {
                <mat-hint align="end" class="payment-edit__iban-hint">{{ iban.value.length }}/ {{ iban.maxLength }}
                </mat-hint>
              }
              @if (paymentEditForm.get('bank.swiftIBAN').hasError('message')) {
                <mat-error class="payment-edit__iban-error">
                  {{ paymentEditForm.get('bank.swiftIBAN').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
            <!--      <div *ngIf="paymentEditForm.get('bank.swiftIBAN').status === 'PENDING'">-->
            @if (this.isSaving === true) {
              <div class="payment-edit__iban-spinner">
                <app-loading-spinner [type]="'small'"></app-loading-spinner>
              </div>
            }
            <mat-form-field class="col-12 payment-edit__bic-field">
              <mat-label class="payment-edit__bic-label"
                         [innerHTML]="translationService.getTranslation('payment_bic')"></mat-label>
              <input matInput formControlName="swiftBIC" required class="payment-edit__bic-input">
              @if (paymentEditForm.get('bank.swiftBIC').hasError('message')) {
                <mat-error class="payment-edit__bic-error">
                  {{ paymentEditForm.get('bank.swiftBIC').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="col-12 payment-edit__bankname-field">
              <mat-label class="payment-edit__bankname-label"
                         [innerHTML]="translationService.getTranslation('payment_bankname')"></mat-label>
              <input matInput formControlName="bankName" required class="payment-edit__bankname-input">
              @if (paymentEditForm.get('bank.bankName').hasError('message')) {
                <mat-error class="payment-edit__bankname-error">
                  {{ paymentEditForm.get('bank.bankName').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
          </ng-container>
        </div>
        <div class="col-12 payment-edit__submit-row">
          <button [hidden]="isSaving" mat-raised-button color="primary" (click)="onSendPayment()"
                  [innerHTML]="translationService.getTranslation('button_send')"
                  class="payment-edit__submit-btn"></button>
        </div>
      </form>
      </div>
    }

    @if (subs && subs.length > 0) {
      <div class="col-12 col-lg-6">

      <div class="mt-5 payment-edit__orders-title">
           <strong [innerHTML]="translationService.getTranslation('payment_affected_orders')"></strong>
      </div>
      @for (sub of subs; track sub; let i = $index) {
        <ng-container class="payment-edit__order-container">
          <div class="form-group col-12 mt-2 payment-edit__order-group">
            <div class="row payment-edit__order-row">
              <div class="col-5 payment-edit__order-label" [innerHTML]="translationService.getTranslation('label_backendid')">
              </div>
              <div class="col-7 payment-edit__order-value">
                {{ sub.userBackendId }}
              </div>
            </div>
          </div>
          <div class="form-group col-12 payment-edit__order-group">
            <div class="row payment-edit__order-row">
              <div class="col-5 payment-edit__order-label" [innerHTML]="translationService.getTranslation('order_id')">
              </div>
              <div class="col-7 payment-edit__order-value">
                {{ sub.backendId }}
              </div>
            </div>
          </div>
          <div class="form-group col-12 payment-edit__order-group">
            <div class="row payment-edit__order-row">
              <div class="col-5 payment-edit__order-label" [innerHTML]="translationService.getTranslation('period')">
              </div>
              <div class="col-7 payment-edit__order-value">
                {{ sub.validDate.validFrom | date: translationService.getTranslation('dateFormat') }} -
                {{ (sub.validDate.validUntil) ? (sub.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless') }}
              </div>
            </div>
          </div>
          @if ((i + 1) < subs.length) {
            <hr class="payment-edit__order-separator">
          }
        </ng-container>
      }
      </div>
    }
    </div>
  </mat-card-content>
</mat-card>

<div class="mt-3 float-end hup-subscription-detail__back">
    <button
      mat-raised-button (click)="backToOverview()"
      [innerHTML]="translationService.getTranslation('button_back_to_overview')"
      class="hup-subscription-detail__back-btn"></button>
</div>
